import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  AxiosResponse,
} from "axios";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_CRECIMIENTO_BACKEND_API_URL ||
  "http://localhost:4004/api";

const negociacionesCrecimientoApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(negociacionesCrecimientoApi);

negociacionesCrecimientoApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesCrecimientoApi };
